<template>
  <div>
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body ">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-single-02 text-warning"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Candidates</p>
                  <p class="card-title">{{ stats.candidates.total }}</p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr />
            <div class="stats d-flex justify-content-between">
              <div>
                <i class="fa fa-refresh"></i>
                Last month
              </div>
              {{ stats.candidates.last_month }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body ">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-send text-success"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Subscribers</p>
                  <p class="card-title">{{ stats.subscribers.total }}</p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr />
            <div class="stats d-flex justify-content-between">
              <div>
                <i class="fa fa-refresh"></i>
                Last month
              </div>
              {{ stats.subscribers.last_month }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body ">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-bank text-danger"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Companies</p>
                  <p class="card-title">{{ stats.companies.total }}</p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr />
            <div class="stats d-flex justify-content-between">
              <div>
                <i class="fa fa-refresh"></i>
                Last month
              </div>
              {{ stats.companies.last_month }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card card-stats">
          <div class="card-body ">
            <div class="row">
              <div class="col-5 col-md-4">
                <div class="icon-big text-center icon-warning">
                  <i class="nc-icon nc-briefcase-24 text-primary"></i>
                </div>
              </div>
              <div class="col-7 col-md-8">
                <div class="numbers">
                  <p class="card-category">Published Offers</p>
                  <p class="card-title">{{ stats.offers.total }}</p>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <hr />
            <div class="stats d-flex justify-content-between">
              <div>
                <i class="fa fa-refresh"></i>
                Last month
              </div>
              {{ stats.offers.last_month }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Dashboard</h3>
          <router-link to="/analytics/form" class="btn btn-primary"
            ><i class="fas fa-plus mr-2"></i> Create Charts</router-link
          >
        </div>
      </div>
    </div>
    <Charts
      class="row py-4"
      @delete="handleDelete"
      @show-form="handleShowForm"
      :charts="charts"
    />
  </div>
</template>

<script>
import Charts from "./Analytics/Charts.vue";
export default {
  components: { Charts },
  data() {
    return {
      charts: [],
      stats: {
        candidates: {
          total: 0,
          last_month: 0
        },
        subscribers: {
          total: 0,
          last_month: 0
        },
        companies: {
          total: 0,
          last_month: 0
        },
        offers: {
          total: 0,
          last_month: 0
        }
      }
    };
  },
  created() {
    this.$http
      .get("enroll_admin/stats")
      .then(({ data }) => (this.stats = data));
    this.$http
      .get("enroll_admin/chart")
      .then(({ data }) => (this.charts = data));
  },
  methods: {
    handleShowForm(id) {
      this.$router.push(`/analytics/form/${id}`);
    },
    handleDelete(id) {
      this.$http.delete(`enroll_admin/chart/${id}`).then(() => {
        this.charts = this.charts.filter(chart => chart.id !== id);
      });
    }
  }
};
</script>
